import React from "react";

import { Newspaper, PencilLine } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { cn } from "@/lib/utils";
import useChatStore from "@/stores/useChatStore";
import useGlobalStore from "@/stores/useGlobalStore";
import { ReactComponent as LogoIcon } from "@/assets/logo.svg";
import { ReactComponent as BetaIcon } from "@/assets/beta.svg";

import ChatHistory from "./ChatHistory";
import OpenSidebar from "./OpenSideBarBtn";

const NAV_WIDTH = 320;

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();

  const { navVisible } = useGlobalStore();
  const setNavVisible = useGlobalStore((store) => store.setNavVisible);
  const loadChatHistory = useChatStore((store) => store.loadChatHistory);
  const handleResetChatStore = useChatStore((store) => store.handleResetChatStore);
  const outerContainerRef = React.useRef(null);

  const handleNewChat = () => {
    handleResetChatStore();
    navigate("/");
    loadChatHistory();
  };

  const handleDailyAI = () => {
    navigate("/reminder");
  };

  const handleScroll = () => {
    if (outerContainerRef.current) {
      outerContainerRef.current.scrollTop = outerContainerRef.current.scrollHeight;
    }
  };

  React.useEffect(() => {
    handleScroll();
  }, []);

  const NavItem = ({ icon: Icon, label, onClick, variant = "default", path }) => {
    const isActive = path ? location.pathname === path : false;

    return (
      <button
        onClick={onClick}
        className={cn(
          "w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left",
          isActive ? "bg-gray-200 text-gray-900" : variant === "primary" ? "bg-gray-100 text-gray-900 hover:bg-gray-200" : "text-gray-700 hover:bg-gray-100"
        )}
      >
        <Icon className="w-4 h-4 flex-shrink-0" />
        <span>{label}</span>
      </button>
    );
  };

  return (
    <>
      {navVisible && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setNavVisible((prev) => false)} />}
      <div
        className={cn("nav active max-w-[280px] flex-shrink-0 overflow-x-hidden bg-surface-primary-alt bg-white", "fixed lg:relative top-0 left-0 h-full z-50")}
        style={{
          width: navVisible ? NAV_WIDTH : "0px",
          visibility: navVisible ? "visible" : "hidden",
          transition: "width 0.3s, visibility 0.35s",
        }}
      >
        <div className="h-full w-[280px]">
          <nav id="chat-history-nav" className="flex h-full flex-col">
            <div className="flex h-full flex-col">
              <div className="flex-shrink-0 p-3">
                <div className="flex items-center justify-between h-12">
                  <div className="flex items-center gap-1">
                    <LogoIcon width={42} height={42} className="rounded-full" />
                    <div className="bg-gradient-to-r from-[#2087ff] to-[#67aef4] bg-clip-text text-transparent uppercase font-bold text-xl">Trợ lý AI</div>
                    <BetaIcon className="ml-1" />
                  </div>
                  <div className="flex items-center gap-2">
                    <OpenSidebar navVisible={true} tooltipContent={"Close Sidebar"} />
                  </div>
                </div>
              </div>

              {/* Navigation Items */}
              <div className="px-3 space-y-1 mb-4">
                <NavItem icon={PencilLine} label="Tạo mới" onClick={handleNewChat} path="/" />
                <NavItem icon={Newspaper} label="Thông tin tổng hợp" onClick={handleDailyAI} path="/reminder" />
              </div>

              <div className="mx-3 border-t border-gray-200 mb-4"></div>

              <div className="flex-1 overflow-y-auto px-3" ref={outerContainerRef}>
                <ChatHistory />
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Nav;
